import { Link, Stack, Typography } from '@mui/material';
import { useEffect } from 'react';

import { FullPageLoaderOverlayWithWhiteBackground } from '@/components/Layout/FullPageLoader';
import { Page } from '@/components/Layout/Page/Page';

import { useTranslate } from '@/hooks/useTranslate';

import { getSuperAppStoreUrl, redirectToSuperAppStore } from '@/utils/superApp';

export default function OpenRepublicSuperAppPage() {
  const { t } = useTranslate();
  const storeUrl = getSuperAppStoreUrl();

  useEffect(() => {
    redirectToSuperAppStore();
  }, []);

  if (!storeUrl) {
    const deepLinkUrl = window.location.href;

    return (
      <Page
        hasLogo
        paperProps={{
          position: 'right',
          size: 'medium',
        }}
      >
        <Stack
          alignItems="stretch"
          data-test-id="open-republic-super-app-content"
          direction="column"
          width="100%"
        >
          <Typography component="h3" variant="headlineH3">
            {t('openRepublicSuperApp.title')}
          </Typography>
          <Typography variant="body1">
            {t('openRepublicSuperApp.description')}
          </Typography>
          <Link href={deepLinkUrl} sx={{ overflowWrap: 'anywhere' }}>
            {deepLinkUrl}
          </Link>
        </Stack>
      </Page>
    );
  }

  return <FullPageLoaderOverlayWithWhiteBackground />;
}
